<div class="layout-auto-1">
	<div class="" *ngIf="VCSyncfusionPdfViewer">
		<div class="grid grid-auto-1 app-pdfviewer-toolbar app-pdfviewer-toolbar-separator-bottom">
			<div class="spawn">
				<ng-container *ngIf="showFileUpload">
					<span [tooltip]="getRessource('tooltips.fileAction.upload')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-file-arrow-up"
					     (click)="viewer.fileUpload.openPicker()">
					  </i>
					</span>
					<i class="app-pdfviewer-toolbar-separator-left"></i>
				</ng-container>

				<span [tooltip]="getRessource('tooltips.navigation.GoToFirstPage')"
				      flow="right">
					<i class="search-filter-action fa-duotone fa-chevrons-left"
					   [class.disabled]="VCSyncfusionPdfViewer.currentPageNumber === 1"
					   (click)="toolbar.navigation.pageChanged(1)">
					</i>
				</span>
				<span [tooltip]="getRessource('tooltips.navigation.PreviousPage')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-chevron-left"
					   [class.disabled]="VCSyncfusionPdfViewer.currentPageNumber === 1"
					   (click)="toolbar.navigation.previousClicked($event)">
					</i>
				</span>
				<div class="app-input-toolbar">
					<input [ngModel]="VCSyncfusionPdfViewer.currentPageNumber"
					       (ngModelChange)="toolbar.navigation.pageChanged($event)"
					       type="number"
					       class="" style="width: 48px; padding: 4px; margin: 4px;"/>
				</div>
				<span class="displayValue app-space-right">
					/ {{VCSyncfusionPdfViewer.pageCount}}
				</span>
				<span [tooltip]="getRessource('tooltips.navigation.NextPage')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-chevron-right"
					   [class.disabled]="VCSyncfusionPdfViewer.currentPageNumber === VCSyncfusionPdfViewer.pageCount"
					   (click)="toolbar.navigation.nextClicked($event)">
					</i>
				</span>
				<span [tooltip]="getRessource('tooltips.navigation.GoToLastPage')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-chevrons-right"
					   [class.disabled]="VCSyncfusionPdfViewer.currentPageNumber === VCSyncfusionPdfViewer.pageCount"
					   (click)="toolbar.navigation.pageChanged(VCSyncfusionPdfViewer.pageCount)">
					</i>
				</span>

			  <i class="app-pdfviewer-toolbar-separator-left"></i>

				<span [tooltip]="getRessource('tooltips.zoom.ZoomIn')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-magnifying-glass-plus "
				   [class.disabled]="toolbar.magnification.zoomIn"
				   (click)="toolbar.magnification.zoomInClicked($event)">
				</i>
				</span>
				<span [tooltip]="getRessource('tooltips.zoom.ZoomOut')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-magnifying-glass-minus"
					   [class.disabled]="toolbar.magnification.zoomOut"
					   (click)="toolbar.magnification.zoomOutClicked($event)">
					</i>
				</span>
				<div class="app-input-toolbar"
				     *ngIf="VCSyncfusionPdfViewer.magnificationModule && VCSyncfusionPdfViewer.zoomPercentage">
					<input [ngModel]="VCSyncfusionPdfViewer.zoomPercentage"
					       (ngModelChange)="toolbar.magnification.zoomTo($event)"
					       type="number"
					       [tooltip]="getRessource('tooltips.')"
					       [defaultValue]="'100'" [disabled]="true"
					       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/> %
				</div>

				<span class="search-filter-action fa-stack"
							[tooltip]="getRessource('tooltips.zoom.FitPage')"
							flow="right"
				      style="margin-left: .25rem"
				      [class.disabled]="toolbar.magnification.fitPage"
				      (click)="toolbar.magnification.pageFitPageClicked($event)">
					<i class="fa-duotone fa-page fa-stack fa-stack-1x"></i>
					<i class="fa-solid fa-up-right-and-down-left-from-center fa-stack-1x fa-xs"></i>
				</span>
				<span class="search-filter-action fa-stack"
							[tooltip]="getRessource('tooltips.zoom.FitWidth')"
							flow="right"
				      style="margin-left: .25rem"
				      [class.disabled]="toolbar.magnification.fitWidth"
				      (click)="toolbar.magnification.pageFitWidthClicked($event)">
					<i class="fa-duotone fa-page fa-stack fa-stack-1x"></i>
					<i class="fa-solid fa-arrows-left-right fa-stack-1x fa-xs"></i>
				</span>
				<span class="search-filter-action fa-stack"
				      flow="right"
							[tooltip]="getRessource('tooltips.zoom.Automatic')"
				      [class.disabled]="toolbar.magnification.fitAuto"
				      (click)="toolbar.magnification.pageFitAutoClicked($event)">
					<i class="fa-duotone fa-magnifying-glass fa-stack fa-stack-1x"></i>
					<i class="fa-solid fa-circle-a fa-stack-1x fa-xs app-fa-pos-BottomLeft"></i>
				</span>
			</div>
			<div class="spawn-reverse">
				<ng-container *ngIf="toolbar.textSearch.searchVisible">
					<span class="app-disabled" *ngIf="toolbar.textSearch.matchCount > 0">
						({{toolbar.textSearch.matchPosition}} von {{toolbar.textSearch.matchCount}})
					</span>
					<span>
						<i class="search-filter-action fa-duotone fa-chevron-up"
						   flow="left"
						   [tooltip]="getRessource('tooltips.fileAction.searchPrevious')"
						   [class.disabled]="!toolbar.textSearch.canSearchPrevious"
						   (click)="toolbar.textSearch.searchPrevious()">
						</i>
						<i class="search-filter-action fa-duotone fa-chevron-down"
						   flow="left"
						   [tooltip]="getRessource('tooltips.fileAction.searchNext')"
						   [class.disabled]="!toolbar.textSearch.canSearchNext"
						   (click)="toolbar.textSearch.searchNext()">
						</i>
					</span>
					<div class="app-input-toolbar" style="margin-right: 4px;">
						<input [(ngModel)]="toolbar.textSearch.searchText"
						       (keydown.enter)="toolbar.textSearch.textSearch($event)"
						       (focusout)="toolbar.textSearch.textSearch($event)"
						       [placeholder]="getRessource('tooltips.fileAction.Searchtext')"
						       class="" style="width: 148px; padding: 2px 0; margin: 2px 0;"/>
						<i class="fa-duotone fa-xmark inEditor"
						   *ngIf="toolbar.textSearch.searchText.length > 0"
							 (click)="toolbar.textSearch.resetSearchText()">
						</i>
					</div>
				</ng-container>
				<span [tooltip]="getRessource('tooltips.fileAction.Findindocument')"
				      flow="left">
				  <i class="search-filter-action fa-duotone fa-magnifying-glass"
				   [class.fa-duotone]="!toolbar.textSearch.searchVisible"
				   [class.fa-solid]="toolbar.textSearch.searchVisible"
				   (click)="toolbar.menu.toggleTextSearch($event)">
				</i>
				</span>
				<span class="search-filter-action fa-stack"
				      [tooltip]="getRessource('tooltips.fileAction.FormDesigner')"
				      flow="left"
				      *ngIf="canShowFormulaToolbar"
				      [class.disabled]="!canShowFormulaToolbar"
				      (click)="toolbar.menu.toggleFormulaToolbar()">
					<i class="fa-duotone fa-input-pipe fa-stack fa-stack-1x">
					</i>
				</span>
				<span class="search-filter-action fa-stack"
							[tooltip]="getRessource('tooltips.fileAction.Annotation')"
							flow="left"
							*ngIf="showAnnotationToolbar"
				      [class.disabled]="!canShowAnnotationToolbar"
				      (click)="toolbar.menu.toggleAnnotationToolbar()">
					<i class="fa-duotone fa-file-pen fa-stack fa-stack-1x">
					</i>
					<i class="fa-notes fa-stack-1x fa-xs app-fa-pos-BottomLeft"
					   [class.fa-solid]="toolbar.menu.showAnnotationToolbar"
					   [class.fa-light]="!toolbar.menu.showAnnotationToolbar">
					</i>
				</span>

				<span [tooltip]="getRessource('tooltips.fileAction.Download')"
				      flow="left">
				  <i class="search-filter-action fa-duotone fa-download"
					   (click)="toolbar.file.downloadClicked($event)">
					</i>
				</span>
			</div>
		</div>
		<div class="grid grid-auto-1 app-pdfviewer-toolbar app-pdfviewer-toolbar-separator-bottom"
		     *ngIf="toolbar.menu.showAnnotationToolbar">
			<div class="spawn">
				<ng-container *ngIf="!showOnlyStamps">
					<span [tooltip]="getRessource('tooltips.')">
					  <i class="search-filter-action fa-duotone fa-comment-captions"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'StickyNotes'"
					     (click)="viewer.annotation.setAnnotationMode('StickyNotes')"
					     *ngIf="viewer.annotation.buttons.comment">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.comment">
					</i>
					<span [tooltip]="getRessource('tooltips.annotation.text.Highlight')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-highlighter-line"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Highlight'"
					     (click)="viewer.annotation.setAnnotationMode('Highlight')"
					     *ngIf="viewer.annotation.buttons.highlighter">
						</i>
					</span>
					<span [tooltip]="getRessource('tooltips.annotation.text.Underline')">
					  <i class="search-filter-action fa-duotone fa-underline"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Underline'"
					     (click)="viewer.annotation.setAnnotationMode('Underline')"
					     *ngIf="viewer.annotation.buttons.underline">
						</i>
					</span>
					<span [tooltip]="getRessource('tooltips.annotation.text.Strikethrough')">
					  <i class="search-filter-action fa-duotone fa-strikethrough"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Strikethrough'"
					     (click)="viewer.annotation.setAnnotationMode('Strikethrough')"
					     *ngIf="viewer.annotation.buttons.strikethrough">
						</i>
					</span>

				</ng-container>
				<ng-container *ngIf="showOnlyStamps">

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.menuStamps && !showOnlyStamps">
					</i>

					<span [tooltip]="getRessource('tooltips.annotation.stamps.checkmark')">
					  <i class="search-filter-action fa-duotone fa-check"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'customStamp'
															 && viewer.annotation.activeAnnotationMode.dynamicStampItem === 'check'"
					     (click)="viewer.annotation.setAnnotationMode('customStamp', 'check')"
					     *ngIf="viewer.annotation.buttons.xmark">
						</i>
					</span>

					<span [tooltip]="getRessource('tooltips.annotation.stamps.circle')">
					  <i class="search-filter-action fa-duotone fa-circle"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'customStamp'
															 && viewer.annotation.activeAnnotationMode.dynamicStampItem === 'circle'"
					     (click)="viewer.annotation.setAnnotationMode('customStamp', 'circle')"
					     *ngIf="viewer.annotation.buttons.circle">
						</i>
					</span>

					<span [tooltip]="getRessource('tooltips.annotation.stamps.crossmark')">
					  <i class="search-filter-action fa-duotone fa-x"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'customStamp'
															 && viewer.annotation.activeAnnotationMode.dynamicStampItem === 'cross'"
					     (click)="viewer.annotation.setAnnotationMode('customStamp', 'cross')"
					     *ngIf="viewer.annotation.buttons.xmark">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.showSubmenu.showStamps">
					</i>
				</ng-container>
				<ng-container *ngIf="!showOnlyStamps">

					<span [tooltip]="getRessource('tooltips.annotation.stamps.customStamp')">
					  <i class="search-filter-action fa-duotone fa-upload"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'customStamp'
															 && viewer.annotation.activeAnnotationMode.dynamicStampItem === 'uploadStamp'"
					     (click)="viewer.annotation.setAnnotationMode('customStamp', 'uploadStamp')"
					     *ngIf="viewer.annotation.buttons.uploadStamp
						          && viewer.annotation.showSubmenu.showStamps">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.menuForms">
					</i>
<!-- 					<span [tooltip]="getRessource('tooltips.annotation.menus.AddForm')"> -->
<!-- 					  <i class="search-filter-action fa-duotone fa-square-dashed-circle-plus" -->
<!-- 					     (click)="viewer.annotation.showSubmenu.showForms = !viewer.annotation.showSubmenu.showForms" -->
<!-- 					     *ngIf="viewer.annotation.buttons.menuForms"> -->
<!-- 						</i> -->
<!-- 					</span> -->

					<ng-container *ngIf="viewer.annotation.showSubmenu.showForms">
						<span [tooltip]="getRessource('tooltips.annotation.forms.Circle')">
							<i class="search-filter-action fa-duotone fa-circle"
							   [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Circle'"
							   (click)="viewer.annotation.setAnnotationMode('Circle')"
							   *ngIf="viewer.annotation.buttons.formCircle">
							</i>
						</span>
						<span [tooltip]="getRessource('tooltips.annotation.forms.Rectangle')">
							<i class="search-filter-action fa-duotone fa-square"
							   [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Rectangle'"
							   (click)="viewer.annotation.setAnnotationMode('Rectangle')"
							   *ngIf="viewer.annotation.buttons.formSquare">
							</i>
						</span>
						<span [tooltip]="getRessource('tooltips.annotation.forms.Polygon')">
							<!-- Icon isn't Center    -->
							<i class="search-filter-action fa-duotone fa-octagon"
							   style="padding-right: 1px;"
							   [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Polygon'"
							   (click)="viewer.annotation.setAnnotationMode('Polygon')"
							   *ngIf="viewer.annotation.buttons.formOctagon">
							</i>
						</span>
						<span [tooltip]="getRessource('tooltips.annotation.forms.Line')">
							<i class="search-filter-action fa-duotone fa-dash"
							   [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Line'"
							   (click)="viewer.annotation.setAnnotationMode('Line')"
							   *ngIf="viewer.annotation.buttons.formDash">
							</i>
						</span>
					</ng-container>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.freeText">
					</i>
					<span [tooltip]="getRessource('tooltips.annotation.text.AddTextbox')">
					  <i class="search-filter-action fa-duotone fa-input-text"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'FreeText'"
					     (click)="viewer.annotation.setAnnotationMode('FreeText')"
					     *ngIf="viewer.annotation.buttons.freeText">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.stamp">
					</i>
					<span [tooltip]="getRessource('tooltips.annotation.')">
					  <i class="search-filter-action fa-duotone fa-stamp"
					     *ngIf="viewer.annotation.buttons.stamp">
						</i>
					</span>
					<span>
					  <i class="app-pdfviewer-toolbar-separator-left"
					     *ngIf="viewer.annotation.buttons.drawing">
							</i>
					</span>
					<span [tooltip]="getRessource('tooltips.annotation.menus.DrawInk')">
					  <i class="search-filter-action fa-duotone fa-pen-swirl"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Ink'"
					     (click)="viewer.annotation.setAnnotationMode('Ink')"
					     *ngIf="viewer.annotation.buttons.drawing">
							</i>
					</span>
					<span>
					  <i class="app-pdfviewer-toolbar-separator-left"
					     *ngIf="viewer.annotation.buttons.signature">
							</i>
					</span>
					<span [tooltip]="getRessource('tooltips.annotation.menus.Signature')">
					  <i class="search-filter-action fa-duotone fa-signature"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'HandWrittenSignature'"
					     (click)="viewer.annotation.setAnnotationMode('HandWrittenSignature')"
					     *ngIf="viewer.annotation.buttons.signature">
						</i>
					</span>
          <div>
            <span [tooltip]="'Stempel'" flow="right">
              <i class="search-filter-action fa-duotone fa-stamp"
                 (click)="toolbar.menu.toggleStempelMenu($event)"
                 *ngIf="viewer.annotation.buttons.userStemps">
              </i>
            </span>
          </div>
          <exg-popup #VCStempelMenu [closeAlways]="false">
            <div class="md-menu content" style="width: 300px; max-height: 400px; overflow-y: auto">
              <div class="md-menu-header" style="display: flex; align-items: center; gap: 8px">
                <span>{{getRessource('tooltips.annotation.userStempel.Header')}}</span>

                <exg-search-bar
                  [placeholder]="getRessource('tooltips.annotation.userStempel.emptySearch')"
                  (Search)="stempelFilter = $event"
                  style="flex: 1; border-bottom: none !important">
                </exg-search-bar>
              </div>
              <div *ngIf="userStempel.length === 0" class="md-menu-item">
                {{getRessource('tooltips.annotation.userStempel.Ghost')}}

              </div>
              <div *ngFor="let s of userStempelFiltered"
                   class="md-menu-item"
                   style="display: flex; align-items: center; gap: 8px"
                   (click)="applyStempel(s)">
                <img [src]="s.stpData" [alt]="s.stpName"
                     style="width:64px; height:64px; object-fit: contain;">
                <span class="typo-small"
                      style="overflow: hidden; text-overflow: ellipsis;">
                  {{ s.stpName }}
                </span>
              </div>
            </div>
          </exg-popup>
					<ng-container *ngIf="viewer.annotation.selectedAnnotationId.length > 0">
						<!-- TextEditors: TextColor; TextSize; Alignments; TextOptions -->
						<ng-container *ngIf="viewer.annotation.showSubmenu.showTextModifiers">
							<i class="app-pdfviewer-toolbar-separator-left">
							</i>
							<span [tooltip]="getRessource('tooltips.annotation.textProperties.Fontcolor')">
								<i class="search-filter-action fa-duotone fa-font"
								   style="margin-right: 1px"
								   [style.--fa-secondary-color]="viewer.annotation.selectedAnnotation?.fontColor !== '#ffffff00' ? viewer.annotation.selectedAnnotation?.fontColor : ''"
								   (click)="viewer.annotation.showSubmenu.showFontColor = !viewer.annotation.showSubmenu.showFontColor"
								   *ngIf="viewer.annotation.buttons.fontFamily">
								</i>
							</span>
							<div class="app-input-toolbar app-space-right_1"
							     *ngIf="viewer.annotation.showSubmenu.showFontColor">
								<input [ngModel]="viewer.annotation.selectedAnnotation?.fontColor"
								       (ngModelChange)="viewer.annotation.modify.fontColor($event)"
								       [tooltip]="getRessource('tooltips.annotation.textProperties.Fontcolor')"
								       type="color"
								       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
								<i class="fa-duotone fa-xmark afterEditor"
								   (click)="viewer.annotation.modify.fontColor('#ffffff00')">
								</i>
							</div>

							<!-- Text Größe -->
							<span [tooltip]="getRessource('tooltips.annotation.textProperties.Fontsize')">
								<i class="search-filter-action fa-font-case"
								   [class.fa-regular]="viewer.annotation.showSubmenu.showFontSize"
								   [class.fa-duotone]="!viewer.annotation.showSubmenu.showFontSize"
								   (click)="viewer.annotation.showSubmenu.showFontSize = !viewer.annotation.showSubmenu.showFontSize"
								   *ngIf="viewer.annotation.buttons.fontSize">
								</i>
							</span>
							<ng-container *ngIf="viewer.annotation.showSubmenu.showFontSize">

								<i class="search-filter-action fa-regular fa-plus"
								   (click)="viewer.annotation.modify.fontSize.increase()"
								   *ngIf="viewer.annotation.selectedAnnotation.fontSize">
								</i>
								<i class="search-filter-action fa-regular fa-minus"
								   style="margin-left: 2px"
								   (click)="viewer.annotation.modify.fontSize.decrease()"
								   *ngIf="viewer.annotation.selectedAnnotation.fontSize">
								</i>

								<div class="app-input-toolbar"
								     *ngIf="viewer.annotation.selectedAnnotation.fontSize">
									<input [ngModel]="viewer.annotation.selectedAnnotation.fontSize"
									       (ngModelChange)="viewer.annotation.modify.fontSize.setSize($event)"
									       type="number"
									       class="" style="width: 48px; padding: 4px; margin: 4px;"/>
								</div>
							</ng-container>

							<!-- Text Alignments -->
							<span [tooltip]="getRessource('tooltips.annotation.textProperties.TextAlign')">
								<i class="search-filter-action fa-regular"
								   (click)="viewer.annotation.showSubmenu.showTextAlignments = !viewer.annotation.showSubmenu.showTextAlignments"
								   [class.fa-align-left]="viewer.annotation.selectedAnnotation?.textAlign === 'Left'"
								   [class.fa-align-justify]="viewer.annotation.selectedAnnotation?.textAlign === 'Justify'"
								   [class.fa-align-right]="viewer.annotation.selectedAnnotation?.textAlign === 'Right'"
								   [class.fa-align-center]="viewer.annotation.selectedAnnotation?.textAlign === 'Center'"
								   *ngIf="viewer.annotation.buttons.menuAlign">
								</i>
							</span>
							<ng-container *ngIf="viewer.annotation.showSubmenu.showTextAlignments">
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Alignleft')">
									<i class="search-filter-action fa-duotone fa-align-left"
									   (click)="viewer.annotation.modify.fontAlignment('Left')"
									   *ngIf="viewer.annotation.buttons.fontAlignLeft
								          && viewer.annotation.selectedAnnotation.textAlign !== 'Left'">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Justify')">
									<i class="search-filter-action fa-duotone fa-align-justify"
									   (click)="viewer.annotation.modify.fontAlignment('Justify')"
									   *ngIf="viewer.annotation.buttons.fontAlignJustify
								          && viewer.annotation.selectedAnnotation.textAlign !== 'Justify'">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Alignright')">
									<i class="search-filter-action fa-duotone fa-align-right"
									   (click)="viewer.annotation.modify.fontAlignment('Right')"
									   *ngIf="viewer.annotation.buttons.fontAlignRight
								          && viewer.annotation.selectedAnnotation.textAlign !== 'Right'">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Center')">
									<i class="search-filter-action fa-duotone fa-align-center"
									   (click)="viewer.annotation.modify.fontAlignment('Center')"
									   *ngIf="viewer.annotation.buttons.fontAlignCenter
								          && viewer.annotation.selectedAnnotation.textAlign !== 'Center'">
									</i>
								</span>
							</ng-container>

							<!-- Text Options -->
							<ng-container *ngIf="viewer.annotation.selectedAnnotation?.fontStyle">
								<span [tooltip]="getRessource('tooltips.annotation.text.Bold')">
									<i class="search-filter-action fa-bold"
									   (click)="viewer.annotation.modify.fontStyle.changeBold()"
									   [class.fa-regular]="viewer.annotation.selectedAnnotation.fontStyle.isBold"
									   [class.fa-duotone]="!viewer.annotation.selectedAnnotation.fontStyle.isBold"
									   *ngIf="viewer.annotation.buttons.fontBold">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Underline')">
									<i class="search-filter-action fa-underline"
									   (click)="viewer.annotation.modify.fontStyle.changeUnderline()"
									   [class.fa-regular]="viewer.annotation.selectedAnnotation.fontStyle.isUnderline"
									   [class.fa-duotone]="!viewer.annotation.selectedAnnotation.fontStyle.isUnderline"
									   *ngIf="viewer.annotation.buttons.fontUnderline">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Strikethrough')">
									<i class="search-filter-action fa-strikethrough"
									   (click)="viewer.annotation.modify.fontStyle.changeStrikeout()"
									   [class.fa-regular]="viewer.annotation.selectedAnnotation.fontStyle.isStrikeout"
									   [class.fa-duotone]="!viewer.annotation.selectedAnnotation.fontStyle.isStrikeout"
									   *ngIf="viewer.annotation.buttons.fontStrikethrough">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Italic')">
									<i class="search-filter-action fa-italic"
									   (click)="viewer.annotation.modify.fontStyle.changeItalic()"
									   [class.fa-regular]="viewer.annotation.selectedAnnotation.fontStyle.isItalic"
									   [class.fa-duotone]="!viewer.annotation.selectedAnnotation.fontStyle.isItalic"
									   *ngIf="viewer.annotation.buttons.fontItalic">
									</i>
								</span>
							</ng-container>
						</ng-container>

						<!-- FormEditor: FillColor; LineColor; LineThickness; Opacity -->
						<i class="app-pdfviewer-toolbar-separator-left">
						</i>
						<ng-container *ngIf="viewer.annotation.showSubmenu.showModifiers">
							<span [tooltip]="getRessource('tooltips.annotation.properties.FillColor')">
								<i class="search-filter-action fa-duotone fa-fill-drip "
								   style="margin-right: 1px"
								   [style.--fa-secondary-color]="viewer.annotation.selectedAnnotation?.fillColor !== '#ffffff00' ? viewer.annotation.selectedAnnotation?.fillColor : ''"
								   (click)="viewer.annotation.showSubmenu.showFillColor = !viewer.annotation.showSubmenu.showFillColor"
								   *ngIf="viewer.annotation.buttons.fillColor">
								</i>
							</span>
							<div class="app-input-toolbar"
							     *ngIf="viewer.annotation.showSubmenu.showFillColor">
								<input [ngModel]="viewer.annotation.selectedAnnotation?.fillColor"
								       (ngModelChange)="viewer.annotation.modify.fillColor($event)"
								       [tooltip]="getRessource('tooltips.annotation.properties.FillColor')"
								       type="color"
								       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
								<i class="fa-duotone fa-xmark afterEditor"
								   (click)="viewer.annotation.modify.fillColor('#ffffff00')">
								</i>
							</div>

							<span [tooltip]="getRessource('tooltips.annotation.properties.Strokeedit')">
								<i class="search-filter-action fa-duotone fa-brush"
								   style="margin-right: 1px"
								   [style.--fa-secondary-color]="viewer.annotation.selectedAnnotation?.strokeColor !== '#ffffff00' ? viewer.annotation.selectedAnnotation?.strokeColor : ''"
								   (click)="viewer.annotation.showSubmenu.showStokeColor = !viewer.annotation.showSubmenu.showStokeColor"
								   *ngIf="viewer.annotation.buttons.lineColor">
								</i>
							</span>
							<div  class="app-input-toolbar"
							      *ngIf="viewer.annotation.showSubmenu.showStokeColor">
								<input [ngModel]="viewer.annotation.selectedAnnotation?.strokeColor"
								       [tooltip]="getRessource('tooltips.annotation.properties.Strokeedit')"
								       (ngModelChange)="viewer.annotation.modify.strokeColor($event)"
								       type="color"
								       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
								<i class="fa-duotone fa-xmark afterEditor"
								   (click)="viewer.annotation.modify.strokeColor('#ffffff00')">
								</i>
							</div>

							<span [tooltip]="getRessource('tooltips.annotation.properties.LineThickness')">
								<i class="search-filter-action fa-duotone fa-dash"
								   style="margin-right: 1px"
								   (click)="viewer.annotation.showSubmenu.showSliderThickness = !viewer.annotation.showSubmenu.showSliderThickness"
								   *ngIf="viewer.annotation.buttons.lineThickness">
								</i>
							</span>
							<div class="app-input-toolbar"
							     *ngIf="viewer.annotation.showSubmenu.showSliderThickness">
								<input [ngModel]="viewer.annotation.selectedAnnotation?.thickness"
								       [tooltip]="getRessource('tooltips.annotation.properties.LineThickness')"
								       (ngModelChange)="VCSyncfusionPdfViewer.annotationModule.modifyThickness($event)"
								       type="number" [step]=".1" [max]="100" [min]=".1"
								       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/> pt
							</div>
						</ng-container>

						<span [tooltip]="getRessource('tooltips.annotation.properties.Opacityedit')">
							<i class="search-filter-action fa-duotone fa-circle-half-stroke"
							   style="margin-right: 1px"
							   (click)="viewer.annotation.showSubmenu.showSliderOpacity = !viewer.annotation.showSubmenu.showSliderOpacity"
							   *ngIf="viewer.annotation.buttons.brightness">
							</i>
						</span>
						<div class="app-input-toolbar"
						     *ngIf="viewer.annotation.showSubmenu.showSliderOpacity">
							<input [ngModel]="viewer.annotation.selectedAnnotation?.opacity*100"
							       [tooltip]="getRessource('tooltips.annotation.properties.Opacityedit')"
							       (ngModelChange)="VCSyncfusionPdfViewer.annotationModule.modifyOpacity($event, true)"
							       type="number" [step]="1" [max]="100" [min]="0"
							       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/> %
						</div>
					</ng-container>
				</ng-container>
			</div>
			<div class="spawn-reverse">
				<span [tooltip]="getRessource('tooltips.annotation.delete')">
				  <i class="search-filter-action fa-duotone fa-trash-can-xmark"
					   (click)="VCSyncfusionPdfViewer.annotationModule.deleteAnnotationById(viewer.annotation.selectedAnnotationId)"
					   *ngIf="viewer.annotation.buttons.annotationDelete && viewer.annotation.selectedAnnotationId.length > 0">
					</i>
				</span>
				<span [tooltip]="getRessource('tooltips.annotation.close')"
				      flow="left">
				  <i class="search-filter-action fa-regular fa-xmark"
					   (click)="toolbar.menu.toggleAnnotationToolbar()"
					   *ngIf="viewer.annotation.buttons.closeToolbar">
					</i>
				</span>
			</div>
		</div>
		<div class="grid grid-auto-1 app-pdfviewer-toolbar app-pdfviewer-toolbar-separator-bottom"
		     *ngIf="toolbar.menu.showFormulaToolbar">
			<div class="spawn">

				<!-- Ausfüll-Modus -->
				<span [tooltip]="getRessource('tooltips.form.mode.fill')"
				      flow="right">
		      <i class="search-filter-action fa-duotone fa-pen-to-square"
		         [class.active]="viewer.forms.mode === 'fill'"
		         (click)="viewer.forms.switchMode('fill')">
		      </i>
		    </span>

				<!-- Design-Modus -->
				<span [tooltip]="getRessource('tooltips.form.mode.design')"
				      flow="right">
		      <i class="search-filter-action fa-duotone fa-arrow-pointer"
		         [class.active]="viewer.forms.mode === 'design'"
		         (click)="viewer.forms.switchMode('design')">
		      </i>
		    </span>

				<ng-container *ngIf="viewer.forms.mode === 'design'">

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.forms.buttons.EditMode">
					</i>
					<span [tooltip]="getRessource('tooltips.form.field.Textbox')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-input-text"
					     [class.active]="viewer.forms.activeMode === 'Textbox'"
					     (click)="viewer.forms.setFormMode('Textbox')"
					     *ngIf="viewer.forms.buttons.Textbox">
						</i>
					</span>
					<span [tooltip]="getRessource('tooltips.form.field.Password')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-input-password"
					     [class.active]="viewer.forms.activeMode === 'Password'"
					     (click)="viewer.forms.setFormMode('Password')"
					     *ngIf="viewer.forms.buttons.Password">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.forms.buttons.Choice">
					</i>
					<span [tooltip]="getRessource('tooltips.form.field.CheckBox')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-square-check"
					     [class.active]="viewer.forms.activeMode === 'CheckBox'"
					     (click)="viewer.forms.setFormMode('CheckBox')"
					     *ngIf="viewer.forms.buttons.CheckBox">
						</i>
					</span>
					<span [tooltip]="getRessource('tooltips.form.field.RadioButton')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-circle-dot"
					     [class.active]="viewer.forms.activeMode === 'RadioButton'"
					     (click)="viewer.forms.setFormMode('RadioButton')"
					     *ngIf="viewer.forms.buttons.RadioButton">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.forms.buttons.DropDown">
					</i>
					<span [tooltip]="getRessource('tooltips.form.field.DropDown')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-list-dropdown"
					     [class.active]="viewer.forms.activeMode === 'DropDown'"
					     (click)="viewer.forms.setFormMode('DropDown')"
					     *ngIf="viewer.forms.buttons.DropdownList">
						</i>
					</span>
					<span [tooltip]="getRessource('tooltips.form.field.ListBox')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-timeline"
					     [class.active]="viewer.forms.activeMode === 'ListBox'"
					     (click)="viewer.forms.setFormMode('ListBox')"
					     *ngIf="viewer.forms.buttons.ListBox">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.forms.buttons.Signature">
					</i>
					<span [tooltip]="getRessource('tooltips.form.field.SignatureField')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-signature"
					     [class.active]="viewer.forms.activeMode === 'SignatureField'"
					     (click)="viewer.forms.setFormMode('SignatureField')"
					     *ngIf="viewer.forms.buttons.SignatureField">
						</i>
					</span>
					<span [tooltip]="getRessource('tooltips.form.field.InitialField')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-pen-field"
					     [class.active]="viewer.forms.activeMode === 'InitialField'"
					     (click)="viewer.forms.setFormMode('InitialField')"
					     *ngIf="viewer.forms.buttons.InitialField">
						</i>
					</span>

					<ng-container *ngIf="viewer.forms.selectedField">
						<i class="app-pdfviewer-toolbar-separator-left">
						</i>
						<!-- Feldname -->
						<span [tooltip]="getRessource('tooltips.form.properties.name')"
						      flow="right">
				      <i class="search-filter-action fa-duotone fa-input-text app-pdfviewer-toolbar-label"></i>
				    </span>
						<div class="app-input-toolbar"
						     [tooltip]="getRessource('tooltips.form.properties.name')"
						     flow="right"
						     style="margin-right: 4px;">
							<input type="text"
							       style="width: 148px; padding: 2px 0; margin: 2px 0;"
							       [value]="viewer.forms.selectedField?.name || ''"
							       (change)="viewer.forms.updateSelectedField({
					               name: $any($event.target).value
					             })"/>
						</div>

						<!-- Tooltip -->
						<span [tooltip]="getRessource('tooltips.form.properties.tooltip')"
						      flow="right">
				      <i class="search-filter-action fa-duotone fa-circle-info app-pdfviewer-toolbar-label"></i>
				    </span>
						<div class="app-input-toolbar"
						     style="margin-right: 4px;"
						     [tooltip]="getRessource('tooltips.form.properties.tooltip')"
						     flow="right">
							<input style="width: 148px; padding: 2px 0; margin: 2px 0;"
							       type="text"
							       [value]="viewer.forms.selectedField?.tooltip || ''"
							       (change)="viewer.forms.updateSelectedField({
				               tooltip: $any($event.target).value
				             })"/>
						</div>

						<i class="app-pdfviewer-toolbar-separator-left"></i>

						<!-- Pflichtfeld -->
						<span [tooltip]="getRessource('tooltips.form.properties.required')"
						      flow="right">
				      <i class="search-filter-action fa-duotone fa-asterisk"
				         [class.active]="viewer.forms.selectedField?.isRequired"
				         (click)="viewer.forms.updateSelectedField({
				           isRequired: !viewer.forms.selectedField?.isRequired
				         })">
				      </i>
				    </span>

						<!-- Schreibgeschützt -->
						<span [tooltip]="getRessource('tooltips.form.properties.readOnly')"
						      flow="right">
				      <i class="search-filter-action fa-duotone fa-lock"
				         [class.active]="viewer.forms.selectedField?.isReadonly"
				         (click)="viewer.forms.updateSelectedField({
				           isReadonly: !viewer.forms.selectedField?.isReadonly
				         })">
				      </i>
				    </span>

						<!-- Mehrzeilig (nur bei Textbox sinnvoll) -->
						<span [tooltip]="getRessource('tooltips.form.properties.multiline')"
						      flow="right"
						      *ngIf="viewer.forms.selectedField?.type === 'Textbox'">
				      <i class="search-filter-action fa-duotone fa-align-left"
				         [class.active]="viewer.forms.selectedField?.isMultiline"
				         (click)="viewer.forms.updateSelectedField({
				           isMultiline: !viewer.forms.selectedField?.isMultiline
				         })">
				      </i>
				    </span>

						<i class="app-pdfviewer-toolbar-separator-left"></i>

						<span [tooltip]="getRessource('tooltips.annotation.properties.FillColor')"
						      flow="right">
							<i class="search-filter-action fa-duotone fa-fill-drip "
							   style="margin-right: 1px"
							   [class.active]="viewer.forms.fieldDesigner.toolbar.showBackgroundColor"
							   [style.--fa-secondary-color]="viewer.forms.selectedField?.backgroundColor !== '#ffffff00' ? viewer.forms.selectedField?.backgroundColor : ''"
							   (click)="viewer.forms.fieldDesigner.toolbar.showBackgroundColor = !viewer.forms.fieldDesigner.toolbar.showBackgroundColor">
							</i>
						</span>
						<div class="app-input-toolbar"
						     *ngIf="viewer.forms.fieldDesigner.toolbar.showBackgroundColor">
							<input [ngModel]="viewer.forms.selectedField?.backgroundColor"
							       (ngModelChange)="viewer.forms.updateSelectedField({
					               backgroundColor: $event
					             })"
							       [tooltip]="getRessource('tooltips.annotation.properties.FillColor')"
							       flow="right"
							       type="color"
							       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
							<i class="fa-duotone fa-xmark afterEditor"
							   (click)="viewer.forms.updateSelectedField({
						               backgroundColor: '#ffffff00'
						             })">
							</i>
						</div>

						<span [tooltip]="getRessource('tooltips.annotation.properties.FillColor')"
						      flow="right">
							<i class="search-filter-action fa-duotone fa-fill-drip "
							   style="margin-right: 1px"
							   [class.active]="viewer.forms.fieldDesigner.toolbar.showBorderColor"
							   [style.--fa-secondary-color]="viewer.forms.selectedField?.borderColor !== '#ffffff00' ? viewer.forms.selectedField?.borderColor : ''"
							   (click)="viewer.forms.fieldDesigner.toolbar.showBorderColor = !viewer.forms.fieldDesigner.toolbar.showBorderColor">
							</i>
						</span>
						<div class="app-input-toolbar"
						     *ngIf="viewer.forms.fieldDesigner.toolbar.showBorderColor">
							<input [ngModel]="viewer.forms.selectedField?.borderColor"
							       (ngModelChange)="viewer.forms.updateSelectedField({
					               borderColor: $event
					             })"
							       [tooltip]="getRessource('tooltips.annotation.properties.FillColor')"
							       flow="right"
							       type="color"
							       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
							<i class="fa-duotone fa-xmark afterEditor"
							   (click)="viewer.forms.updateSelectedField({
						               borderColor: '#ffffff00'
						             })">
							</i>
						</div>

						<span [tooltip]="getRessource('tooltips.annotation.properties.LineThickness')"
						      flow="right">
							<i class="search-filter-action fa-duotone fa-dash"
							   style="margin-right: 1px"
							   [class.active]="viewer.forms.fieldDesigner.toolbar.showSliderThickness"
							   (click)="viewer.forms.fieldDesigner.toolbar.showSliderThickness = !viewer.forms.fieldDesigner.toolbar.showSliderThickness">
							</i>
						</span>
						<div class="app-input-toolbar"
						     *ngIf="viewer.forms.fieldDesigner.toolbar.showSliderThickness">
							<input [ngModel]="viewer.forms.selectedField?.thickness"
							       [tooltip]="getRessource('tooltips.annotation.properties.LineThickness')"
							       flow="right"
							       (ngModelChange)="viewer.forms.updateSelectedField({
					               thickness: $event
					             })"
							       type="number" [step]=".1" [max]="100" [min]=".1"
							       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/> pt
						</div>

						<!-- Schriftgröße -->
						<ng-container *ngIf="viewer.forms.selectedField?.type === 'Textbox'
		              || viewer.forms.selectedField?.type === 'Password'">
							<i class="app-pdfviewer-toolbar-separator-left"></i>

							<span [tooltip]="getRessource('tooltips.annotation.textProperties.Fontsize')"
							      flow="right">
					      <i class="search-filter-action fa-duotone fa-text-size app-pdfviewer-toolbar-label"
					         [class.active]="viewer.forms.fieldDesigner.toolbar.showFontSize"
					         (click)="viewer.forms.fieldDesigner.toolbar.showFontSize = !viewer.forms.fieldDesigner.toolbar.showFontSize"
					      >
					      </i>
					    </span>
							<ng-container *ngIf="viewer.forms.fieldDesigner.toolbar.showFontSize">
								<div class="app-input-toolbar"
								     style="margin-right: 4px;"
								     [tooltip]="getRessource('tooltips.annotation.textProperties.Fontsize')"
								     flow="right">
									<input type="number"
									       style="width: 54px; padding: 2px 0; margin: 2px 0;"
									       min="6" max="72"
									       disabled="true"
									       [ngModel]="viewer.forms.selectedField?.fontSize || 12"
									       (ngModelChange)="viewer.forms.updateSelectedField({
							               fontSize: $event
							             })"/>
								</div>
								<i class="search-filter-action fa-regular fa-plus"
								   (click)="viewer.forms.fieldDesigner.increaseFontSize()">
								</i>
								<i class="search-filter-action fa-regular fa-minus"
								   style="margin-left: 2px"
								   (click)="viewer.forms.fieldDesigner.decreaseFontSize()">
								</i>
							</ng-container>

							<span [tooltip]="getRessource('tooltips.annotation.textProperties.Fontcolor')"
							      flow="right">
								<i class="search-filter-action fa-duotone fa-font"
								   style="margin-right: 1px"
								   [class.active]="viewer.forms.fieldDesigner.toolbar.showFontColor"
								   [style.--fa-secondary-color]="viewer.forms.selectedField?.color !== '#ffffff00' ? viewer.forms.selectedField?.color : ''"
								   (click)="viewer.forms.fieldDesigner.toolbar.showFontColor = !viewer.forms.fieldDesigner.toolbar.showFontColor">
								</i>
							</span>
							<div class="app-input-toolbar app-space-right_1"
							     *ngIf="viewer.forms.fieldDesigner.toolbar.showFontColor">
								<input [ngModel]="viewer.forms.selectedField?.fontColor"
								       (ngModelChange)="viewer.forms.updateSelectedField({
						               color: $event
						             })"
								       [tooltip]="getRessource('tooltips.annotation.textProperties.Fontcolor')"
								       flow="right"
								       type="color"
								       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
								<i class="fa-duotone fa-xmark afterEditor"
								   (click)="viewer.forms.updateSelectedField({
						               color: '#ffffff00'
						             })">
								</i>
							</div>


							<!-- Text Alignments -->
							<span [tooltip]="getRessource('tooltips.annotation.textProperties.TextAlign')"
							      flow="right">
								<i class="search-filter-action fa-regular"
								   [class.active]="viewer.forms.fieldDesigner.toolbar.showTextAlignments"
								   (click)="viewer.forms.fieldDesigner.toolbar.showTextAlignments = !viewer.forms.fieldDesigner.toolbar.showTextAlignments"
								   [class.fa-align-left]="viewer.forms.selectedField?.alignment.toLowerCase() === 'left'"
								   [class.fa-align-right]="viewer.forms.selectedField?.alignment.toLowerCase() === 'right'"
								   [class.fa-align-center]="viewer.forms.selectedField?.alignment.toLowerCase() === 'center'">
								</i>
							</span>
							<ng-container *ngIf="viewer.forms.fieldDesigner.toolbar.showTextAlignments">
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Alignleft')"
								      flow="right">
									<i class="search-filter-action fa-duotone fa-align-left"
									   (click)="viewer.forms.updateSelectedField({
						               alignment: 'Left'
						             })"
									   *ngIf="viewer.forms.selectedField?.alignment.toLowerCase() !== 'left'">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Alignright')"
								      flow="right">
									<i class="search-filter-action fa-duotone fa-align-right"
									   (click)="viewer.forms.updateSelectedField({
						               alignment: 'Right'
						             })"
									   *ngIf="viewer.forms.selectedField?.alignment.toLowerCase() !== 'right'">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Center')"
								      flow="right">
									<i class="search-filter-action fa-duotone fa-align-center"
									   (click)="viewer.forms.updateSelectedField({
						               alignment: 'Center'
						             })"
									   *ngIf="viewer.forms.selectedField?.alignment.toLowerCase() !== 'center'">
									</i>
								</span>
							</ng-container>

							<!-- Text Options -->
							<ng-container *ngIf="viewer.forms.selectedField?.fontStyle !== undefined">
							  <span [tooltip]="getRessource('tooltips.annotation.text.Bold')"
							        flow="right">
							    <i class="search-filter-action fa-bold"
							       (click)="viewer.forms.fieldDesigner.toggleFontStyle('Bold')"
							       [class.fa-regular]="viewer.forms.fieldDesigner.isFontStyleActive('Bold')"
							       [class.fa-duotone]="!viewer.forms.fieldDesigner.isFontStyleActive('Bold')">
							    </i>
							  </span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Underline')"
								      flow="right">
							    <i class="search-filter-action fa-underline"
							       (click)="viewer.forms.fieldDesigner.toggleFontStyle('Underline')"
							       [class.fa-regular]="viewer.forms.fieldDesigner.isFontStyleActive('Underline')"
							       [class.fa-duotone]="!viewer.forms.fieldDesigner.isFontStyleActive('Underline')">
							    </i>
							  </span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Strikethrough')"
								      flow="right">
							    <i class="search-filter-action fa-strikethrough"
							       (click)="viewer.forms.fieldDesigner.toggleFontStyle('Strikeout')"
							       [class.fa-regular]="viewer.forms.fieldDesigner.isFontStyleActive('Strikeout')"
							       [class.fa-duotone]="!viewer.forms.fieldDesigner.isFontStyleActive('Strikeout')">
							    </i>
							  </span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Italic')"
								      flow="right">
							    <i class="search-filter-action fa-italic"
							       (click)="viewer.forms.fieldDesigner.toggleFontStyle('Italic')"
							       [class.fa-regular]="viewer.forms.fieldDesigner.isFontStyleActive('Italic')"
							       [class.fa-duotone]="!viewer.forms.fieldDesigner.isFontStyleActive('Italic')">
							    </i>
							  </span>
							</ng-container>
							<i class="app-pdfviewer-toolbar-separator-left"></i>

							<span [tooltip]="getRessource('tooltips.form.properties.maxLength')"
							      flow="right">
					      <i class="search-filter-action fa-duotone fa-text-size app-pdfviewer-toolbar-label"
					         [class.active]="viewer.forms.fieldDesigner.toolbar.showMaxLength"
					         (click)="viewer.forms.fieldDesigner.toolbar.showMaxLength = !viewer.forms.fieldDesigner.toolbar.showMaxLength">
					      </i>
					    </span>

							<ng-container *ngIf="viewer.forms.fieldDesigner.toolbar.showMaxLength">
								<div class="app-input-toolbar"
								     style="margin-right: 4px;"
								     [tooltip]="getRessource('tooltips.form.properties.maxLength')"
								     flow="right">
									<input type="number"
									       style="width: 72px; padding: 2px 0; margin: 2px 0;"
									       min="1" step="1"
									       [ngModel]="viewer.forms.selectedField?.maxLength"
									       (ngModelChange)="viewer.forms.updateSelectedField({
							               maxLength: $event
							             })"/>
								</div>
							</ng-container>
						</ng-container>
					</ng-container>
				</ng-container>
			</div>
			<div class="spawn-reverse">
				<span [tooltip]="getRessource('tooltips.form.deleteField')"
				      flow="left">
				  <i class="search-filter-action fa-duotone fa-trash-can-xmark"
					   (click)="viewer.forms.deleteSelected()"
					   *ngIf="viewer.forms.buttons.deleteForm && viewer.forms.selectedField && viewer.forms.mode === 'design'">
					</i>
				</span>
				<span [tooltip]="getRessource('tooltips.form.deleteValue')"
				      flow="left">
				  <i class="search-filter-action fa-duotone fa-trash-can-xmark"
					   (click)="viewer.forms.clearSelectedFieldValue()"
					   *ngIf="viewer.forms.buttons.deleteForm && viewer.forms.selectedField && viewer.forms.mode === 'fill'">
					</i>
				</span>
				<span [tooltip]="getRessource('tooltips.annotation.close')"
				      flow="left">
				  <i class="search-filter-action fa-regular fa-xmark"
					   (click)="toolbar.menu.toggleFormulaToolbar()"
					   *ngIf="viewer.forms.buttons.closeToolbar">
					</i>
				</span>
			</div>
		</div>
	</div>
	<div class="content" *ngIf="init && docID">
		<ejs-pdfviewer [id]="'pdfViewer_' + docID"

		               [serviceUrl]="service"
		               [documentPath]="docPath"
		               [dateTimeFormat]="'yyyy-MM-dd HH:mm:ss'"

		               [locale]="'de'"
		               style="height: 100%;"

		               [enableToolbar]="false"
		               [enableNavigationToolbar]="false"
		               [enableAnnotationToolbar]="false"
		               [enableFormDesignerToolbar]="false"
		               [enableCommentPanel]="false"

		               [enableAnnotation]="true"
		               [enableFormFields]="true"
		               [enableFormDesigner]="true"
		               [enableTextSearch]="true"
		               [enableTextSelection]="true"

		               [isSignatureEditable]="true"
		               [isExtractText]="true"

		               [annotationSettings]="viewerConfig.settings.AnnotationSettings"
		               [freeTextSettings]="viewerConfig.settings.freeTextSettings"
		               [stickyNotesSettings]="viewerConfig.settings.stickyNoteSettings"
		               [handWrittenSignatureSettings]="viewerConfig.settings.handWrittenSignatureSettings"

		               hyperlinkOpenState="NewTab"
		               (pageClick)="viewer.page.onClick($event)"
		               (hyperlinkClick)="viewer.hyperlinkClicked($event)"

		               (documentLoad)="viewer.file.documentLoaded($event)"
		               (documentLoadFailed)="viewer.reload()"

		               (downloadStart)="toolbar.file.downloadStart()"
		               (extractTextCompleted)="viewer.text.extractText($event)"

		               (textSelectionEnd)="viewer.selection.textSelected($event)"
		               (textSearchStart)="toolbar.textSearch.textSearchStart($event)"
		               (textSearchHighlight)="toolbar.textSearch.textSearchComplete($event)"

		               (annotationAdd)="viewer.annotation.annotationEventListener($event)"
		               (annotationSelect)="viewer.annotation.annotationEventListener($event)"
		               (annotationUnSelect)="viewer.annotation.annotationEventListener($event)"
		               (annotationRemove)="viewer.annotation.annotationEventListener($event)"
		               (annotationMove)="viewer.annotation.annotationEventListener($event)"
		               (annotationResize)="viewer.annotation.annotationEventListener($event)"
		               (annotationPropertiesChange)="viewer.annotation.annotationEventListener($event)"

		               (formFieldClick)="viewer.forms.eventListener($event)"
		               (formFieldDoubleClick)="viewer.forms.eventListener($event)"
		               (formFieldSelect)="viewer.forms.eventListener($event)"
		               (formFieldUnselect)="viewer.forms.eventListener($event)"
		               (formFieldAdd)="viewer.forms.eventListener($event)"
		               (formFieldRemove)="viewer.forms.eventListener($event)"
		               (formFieldPropertiesChange)="viewer.forms.eventListener($event)"
		               (formFieldMove)="viewer.forms.eventListener($event)"
		               (formFieldResize)="viewer.forms.eventListener($event)"
		               (formFieldFocusOut)="viewer.forms.eventListener($event)"

		               (commentAdd)="viewer.annotation.commentEventListener($event)"
		               (commentEdit)="viewer.annotation.commentEventListener($event)"
		               (commentDelete)="viewer.annotation.commentEventListener($event)"
		               (commentSelect)="viewer.annotation.commentEventListener($event)"
		               (commentStatusChanged)="viewer.annotation.commentEventListener($event)"

									 (signatureSelect)="viewer.annotation.signatureSelect($event)"
									 (signatureUnselect)="viewer.annotation.signatureUnselect($event)"
		>
		</ejs-pdfviewer>
	</div>
	<input type="file" #fileUpload accept=".png,.jpeg" style="visibility: hidden">
	<div id="docID" style="visibility: hidden">{{docID}}</div>
	<!-- Verstecktes File-Input -->
	<input #toolbarFileUpload
	       type="file"
	       [accept]="viewer.fileUpload.accept"
	       style="display: none;"
	       (change)="viewer.fileUpload.onFileSelected($event)"/>
</div>
